import { useCallback } from 'react';

import { useGenericSend } from '@core/js/hooks/socket/hooks/useGenericSend/useGenericSend';
import * as Types from './types';

export const useRemovePlayerTags = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.IRemovePlayerTagsRequestData): Promise<Types.IRemovePlayerTagsResponseData> => {
        const { data } = await send<Types.IRemovePlayerTagsRequestData, Types.IRemovePlayerTagsResponseData>({
            ID: 35553,
            description: 'Remove player tags',
            responses: [35554, 35555],
            errorLevel: 1,
            ...request
        });

        return data;
    }, [
        send
    ]);
};
